<template>
  <v-layout row wrap>
    <v-flex xs12 class="position-relative awesomplete-container">
      <textarea
        :ref="autoCompleteRef"
        v-model="text"
        v-validate="`required|max:${maxLengthText}`"
        data-vv-name="text"
        data-vv-as="texto"
        placeholder="Texto"
        @keydown.enter="avoidEmptyLines($event)"
        :class="{ awesomplete: true, 'has-error': errors.has('text') }"
        data-multiple
        spellcheck="false">
      </textarea>
    </v-flex>
    <v-flex xs12>
      <div>
        <small class="grey--text f1em" id="text-error">
          {{ totalCharacter }} / {{ maxLengthText }}
        </small>
        <small class="activeClass d-block" v-if="hasSpecialChar">
          No se admiten caracteres especiales en las plantillas SMS
        </small>
        <small class="activeClass d-block" id="text-error" v-if="errors.has('text')">
          {{ errors.first('text') }}
        </small>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import autoCompleteMixin from '@/mixins/autoComplete';

export default {
  inject: ['$validator'],
  mixins: [
    autoCompleteMixin,
  ],
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Object,
      default: () => {},
    },
    autocompleteList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      text: '',
      maxLengthText: 160,
      autoCompleteRef: 'awesompletesms',
    };
  },
  computed: {
    hasSpecialChar() {
      return /[^\w\s,.*$%/-@_]+/g.test(this.text);
    },
    totalCharacter() {
      const tmp = document.createElement('div');
      tmp.innerHTML = this.text;
      return (tmp.textContent || tmp.innerText).length || 0;
    },
  },
  watch: {
    selected: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value && Object.keys(value).length > 0 && this.text !== value) {
          this.text = value.sms;
        }
      },
    },
    text(value) {
      this.form.sms = value;
    },
  },
};
</script>

<style scoped>
  .awesomplete-container >>> .awesomplete {
    min-height: 160px;
  }
</style>


// WEBPACK FOOTER //
// src/components/templateV2/SmsForm.vue